<script>
export default {
	props: {
		showDialog: Boolean,
		indexValue: Number,
		mediaItems: Array,
	},
	model: {
		prop: 'indexValue',
		event: 'updateIndexValue',
	},
	data() {
		return {
			currentIndex: this.indexValue,
			scale: 0,
		}
	},
	watch: {
		indexValue(value, oldValue) {
			this.currentIndex = value || 0
			this.scale = 0
		},
		currentIndex(value, oldValue) {
			this.$emit('updateIndexValue', value)
			this.stopVideoPlayback(oldValue)
		},
		showDialog(value) {
			const metaViewport = document.querySelector('meta[name="viewport"]')
			if (metaViewport) {
				metaViewport.setAttribute(
					'content',
					value
						? 'width=device-width, initial-scale=1.0'
						: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
				)
			}
		},
	},
	computed: {
		containerStyle() {
			return {}
		},
		activeImgRef() {
			return this.$refs.mediaContainer?.$el
		},
	},
	methods: {
		getHandlers(mediaItem) {
			if (mediaItem.type == 'video') return {}
			if (this.$b.d) return { click: this.toggleScale }
		},
		stopVideoPlayback(index) {
			const mediaContainer = this.$refs.mediaContainer?.$el
			if (!mediaContainer) return

			const oldSlide = mediaContainer.querySelector(`.img:nth-child(${index + 1}) video`)
			if (oldSlide) {
				// oldSlide.currentTime = 0
				oldSlide.pause()
			}
		},
		closeDialog() {
			this.$emit('update:show-dialog', false)
		},
		toggleScale() {
			this.scale += 1
			if (this.scale > 2) {
				this.scale = 0
			}
		},
	},
}
</script>

<template>
	<v-dialog :value="showDialog" persistent dark fullscreen transition="fade-transition">
		<div class="d-flex align-center justify-center overlay h100">
			<ContentSwitcher
				ref="mediaContainer"
				:items="mediaItems"
				v-model="currentIndex"
				class="w100 h100"
				:show-arrows="$b.d"
				show-dots
			>
				<template #default="{ item }">
					<Media
						class="img w100"
						:class="{
							scale1: scale == 1,
							scale2: scale == 2,
							'pt-60': $b.m,
							'pt-80': $b.t,
						}"
						ref="media"
						v-on="getHandlers(item)"
						:src="!item._multiple ? item : item.big"
						:style="containerStyle"
						width="100%"
						scale-down
						loader
						aspect-ratio="1"
						:video-props="{
							class: 'text-center',
							videoAttrs: {
								controls: true,
								width: $b.d ? 'auto' : '100%',
								height: $b.d ? '100%' : 'auto',
							},
						}"
						:youtube-video-props="{
							iframeAttrs: {
								frameborder: 0,
							},
						}"
					/>
				</template>
			</ContentSwitcher>
			<Button class="place-up" absolute top right icon x-large @click="closeDialog" dark>
				<v-icon x-large>mdi-close</v-icon>
			</Button>
		</div>
	</v-dialog>
</template>

<style scoped lang="scss">
@import '~vuetify/src/styles/styles.sass';

.place-up {
	z-index: 9999;
}
.overlay {
	background-color: rgba(0, 0, 0, 0.8);
	height: 100%;
}
.img {
	transform-origin: center;
	transition: 0.3s all;
	height: calc(100% - 26px);
}
.img.scale1 {
	transform: scale(1.2);
}
.img.scale2 {
	transform: scale(1.4);
}

.pt-80 {
	padding-top: 80px !important;
}

.pt-60 {
	padding-top: 60px !important;
}

::v-deep .content-switcher .__content-wrapper {
	overflow: hidden;
}

::v-deep .content-switcher .__dots {
	position: absolute;
	bottom: 0;
	margin: 0 auto;
	height: 20px;
}

::v-deep .content-switcher.--mobile .__dots {
	height: 20px !important;
}

::v-deep .ratio-box__slot {
	@media #{map-get($display-breakpoints, 'sm-and-down')} {
		display: flex;
		justify-content: center;
		align-items: center;
	}
}
</style>

